import { SearchCategory } from "@nosto/nosto-js/client"
import { AutocompleteElement } from "@nosto/search-js/preact/autocomplete"

type CategoryProps = {
  category: SearchCategory
}

export default function Category({ category }: CategoryProps) {
  return (
    <AutocompleteElement
      key={category.url}
      hit={category}
      as="a"
      componentProps={{
        href: category.url,
        "aria-label": `Category ${category.fullName ?? category.name}`
      }}
    >
      {category.fullName ?? category.name}
    </AutocompleteElement>
  )
}
